(function () {
  'use strict';

  function selectTab(root, tabId) {
    root.querySelectorAll('[role="tab"]').forEach(function (btn) {
      var on = btn.id === tabId;
      btn.setAttribute('aria-selected', String(on));
      btn.tabIndex = on ? 0 : -1;
      var panel = root.querySelector('#' + btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }

  function initMenu(root) {
    if (root.dataset.voroMmReady) return;
    root.dataset.voroMmReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    root.querySelectorAll('[role="tabpanel"]').forEach(function (p) {
      p.hidden = p.getAttribute('data-voro-mm-default') !== 'true';
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[role="tab"]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      selectTab(root, btn.id);
    });

    root.addEventListener('keydown', function (e) {
      var btn = e.target.closest('[role="tab"]');
      if (!btn) return;
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var list = Array.prototype.slice.call(btn.parentElement.querySelectorAll('[role="tab"]'));
      var step = e.key === 'ArrowRight' ? 1 : list.length - 1;
      var next = list[(list.indexOf(btn) + step) % list.length];
      selectTab(root, next.id);
      next.focus();
    });
  }

  function init() {
    document.querySelectorAll('[data-voro-mm]').forEach(initMenu);
  }

  document.addEventListener('mouseenter', function (e) {
    var holder = e.target.closest && e.target.closest('.nav__link__holder--voro-mm');
    if (!holder) return;
    document.querySelectorAll('.nav__link__holder--voro-mm').forEach(function (h) {
      var panel = h.querySelector('[data-voro-mm]:not(.voro-mm--mobile)');
      if (panel) panel.classList.toggle('is-suppressed', h !== holder);
    });
  }, true);

  document.addEventListener('mouseleave', function (e) {
    if (!e.target.closest || !e.target.closest('.page__header')) return;
    var focused = document.activeElement;
    if (focused && focused.closest && focused.closest('[data-voro-mm]:not(.voro-mm--mobile)')) {
      focused.blur();
    }
    document.querySelectorAll('[data-voro-mm].is-suppressed')
      .forEach(function (p) { p.classList.remove('is-suppressed'); });
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var panel = document.activeElement && document.activeElement.closest('[data-voro-mm]');
    if (!panel) return;
    if (panel.classList.contains('voro-mm--mobile')) return;
    panel.classList.add('is-dismissed');
    var holder = panel.closest('.nav__link__holder');
    var trigger = holder && holder.querySelector('.nav__link');
    if (trigger) trigger.focus();
  });

  function clearDismissed(holder) {
    if (!holder) return;
    holder.querySelectorAll('[data-voro-mm].is-dismissed')
      .forEach(function (p) { p.classList.remove('is-dismissed'); });
  }

  function undismiss(e) {
    clearDismissed(e.target.closest && e.target.closest('.nav__link__holder'));
  }
  document.addEventListener('mouseenter', undismiss, true);
  document.addEventListener('click', undismiss, true);

  document.addEventListener('focusout', function (e) {
    var holder = e.target.closest && e.target.closest('.nav__link__holder');
    if (!holder) return;
    setTimeout(function () {
      if (!holder.contains(document.activeElement)) clearDismissed(holder);
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
